import { CustomListKey } from "@sp-crm/core";
import { ContentFull, ContentHeader, ContentSubheader } from "components/layout";
import React from "react";
import { useFeature } from "store/selectors/hooks";
import { CustomListEditor } from "./custom-list-editor";

export const AgencySettingsHomeCare: React.FC<unknown> = () => {
    const homeCareEnabled = useFeature("homeCarePrototype");

    if (!homeCareEnabled) {
        return null;
    }

    return (
        <div className="space-y-4 lg:space-y-8">
            <ContentFull>
                <ContentHeader>Home Care Lead Statuses</ContentHeader>
                <ContentSubheader>
                    Customize home care lead status labels, order, and categories to
                    support your home care workflow.
                </ContentSubheader>
                <CustomListEditor customListKey={CustomListKey.HomeCareLeadStatus} />
            </ContentFull>
        </div>
    );
};
